"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_missing_1 = require("../any/is-missing");
/*
 * Return the same object excluding keys without values.
 *
 * @Param {Object} object = An object.
 *
 * @Example
 *
 *     compact({ pizza: 'Mmm', banana: undefined, salad: null })
 *     //=> { pizza: 'Mmm' }
 */
function compact(object) {
    return Object.entries(object).reduce((acc, [key, value]) => {
        if (is_missing_1.isMissing(value))
            return Object.assign({}, acc);
        return Object.assign({}, acc, { [key]: value });
    }, {});
}
exports.compact = compact;
//# sourceMappingURL=compact.js.map